/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../components.ts"/>


module DealerwareWebComponents {

    "use strict";

    export class SettingsLoanerAgreementSummaryDirectiveController {

        public static $inject : string[ ] = [
            '$scope',
            '$stateParams',
            'SettingsLoanerAgreementSummaryService',
            '$mobilityCompanyAuthentication',
            '$dealerwareNotification',
            '$dealerwareLoading',
            '$mdDialog',
            '$timeout'
        ];

        public newBullet   : string = '';
        public bullets     : any[]  = [ ];

        constructor(
            public $scope                                   : any,
            public $stateParams                             : any,
            public SettingsLoanerAgreementSummaryService    : any,
            public $auth                                    : any,
            public $dealerwareNotification                  : any,
            public $dealerwareLoading                       : any,
            public $mdDialog                                : any,
            public $timeout                                 : any
        ) {
            this.getBullets();
        }

        public addBullet () : void {

            var loader = this.$dealerwareLoading.show ('Adding...');

            this.bullets.push(
                {
                    location_id     : this.$auth.location.id,
                    text            : this.newBullet,
                    sortOrderIndex  : this.bullets.length
                }
            );

            this.saveBullets(loader);
        }

        public reSortBullets (index : number, sortDirection : number) : void {

            var loader = this.$dealerwareLoading.show ('Updating...');

            this.bullets[index].sortOrderIndex                  += sortDirection;
            this.bullets[index + sortDirection].sortOrderIndex  += sortDirection * -1;

            this.saveBullets(loader);

            this.bullets[index].isEdit = false;
        }

        // For swapping the sort order between two adjacent items, this resorts back to ascending
        // numeric_order.  For deletions, this renumbers the items into one contiguous block, if the
        // deleted bullet leaves a gap in the numeric_order for the remaining bullets.
        //
        public synchronizeBulletSortOrder () : boolean {

            var saveBullets = false;

            angular.forEach(this.bullets.sort(
                ( a : any, b : any ) => {
                    return a.sortOrderIndex - b.sortOrderIndex;
                }),
                ( bullet : any, i : number ) => {

                    if (bullet.sortOrderIndex !== i) {
                        bullet.sortOrderIndex = i;
                        saveBullets = true;
                    }
                }
            );

            return saveBullets;
        }

        public editBullet (index : number) : void {

            this.bullets.forEach( ( bullet : any ) => {
                bullet.isEdit = false;
            });
            this.bullets[index].isEdit = true;
        }

        public cancelEditBullet (index : number) : void {

            this.bullets[index].text = this.bullets[index].originalText;
            this.bullets[index].isEdit = false;
        }

        public updateBullet (bullet : any) : void {

            var loader = this.$dealerwareLoading.show ('Updating...');

            this.saveBullets(loader);
        }

        public deleteBullet (index : number) : void {

            var that = this;

            var confirm = this.$mdDialog.confirm()
                .textContent('Are you sure you want to delete this Driver Agreement bullet point?')
                .ariaLabel('Are you sure you want to delete this Driver Agreement bullet point?')
                .ok('Confirm Delete')
                .cancel('Cancel Delete');

            this.$mdDialog.show(confirm)
                .then( ( ) => {
                    var loader = that.$dealerwareLoading.show ('Deleting...');

                    that.SettingsLoanerAgreementSummaryService.deleteBullet (that.$auth.location.id, that.bullets[index].id)
                        .then( (bullets : any) => {

                            that.bullets = bullets;

                            // Still working on sexying up deletions so the bullet fades out before vanishing
                            // from the list.
                            //
                            //that.bullets[index].beingDeleted = 1;
                            //that.$timeout( ( ) => {
                            //}, 1000);

                            // Resave the bullet list if we've got a discontinuity in the sort orders.
                            //
                            if (that.synchronizeBulletSortOrder()) {
                                that.saveBullets(loader, true);
                            }
                            else {
                                // Because of this wackiness, we have to put this here rather than in a .finally
                                // block, and the .hide will be taken care of by saveBullets().
                                //
                                loader.close();
                            }
                        })
                        .catch( (response : any) => {
                            loader.close();
                            that.$dealerwareNotification.apiError(response, '');
                        });
                });
        }

        public saveBullets (loader: any, skipSortSynchronization? : boolean) : void {

            // Delete bullet had to run the sync code in order to determine whether
            // running saveBullets() was necessary, so don't do it again.
            //
            if (! skipSortSynchronization) {
                this.synchronizeBulletSortOrder();
            }

            var that = this;

            // Always save back all the bullets, for sort order reasons, see above comments.
            //
            this.SettingsLoanerAgreementSummaryService.saveBullets(
                this.$auth.location.id,
                this.bullets
            )
                .then( (bullets : any) => {
                    that.bullets = bullets;
                    that.newBullet = '';

                    // I don't get why this doesn't do what it's supposed to do.  The UX problem
                    // that this code doesn't succeed in fixing is minor, though it should be fixed
                    // before release.  It doesn't seem to hurt to have this stuff in here even if
                    // it doesn't work.
                    //
                    that.$scope.loanerAgreementSummaryForm.addBulletText.$setPristine(true);
                    that.$scope.loanerAgreementSummaryForm.addBulletText.$setValidity(
                        'required', true
                    );
                    that.$scope.loanerAgreementSummaryForm.addBulletText.$validate();
                })
                .catch( (response : any) => {
                    that.$dealerwareNotification.apiError(response, '');
                })
                .finally( ( ) => {
                    loader.close();
                });
        }

        public getBullets  ( ) : void {

            var that = this;

            return this.SettingsLoanerAgreementSummaryService.getBullets (this.$auth.location.id)
                .then( (bullets : any) => {
                    that.bullets = bullets;
                })
                .catch( (response : any) => {
                    that.$dealerwareNotification.apiError(response, '');
                });
        }
    }

    getDealerwareWebComponentsModule().controller(
        'SettingsLoanerAgreementSummaryDirectiveController',
        SettingsLoanerAgreementSummaryDirectiveController
    );



    export class SettingsLoanerAgreementSummaryDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'SettingsLoanerAgreementSummaryDirectiveController';
        public controllerAs     : string    =   'settingsLoanerAgreementSummaryController';
        public bindToController : boolean   =   true;
        public templateUrl      : string    =   '/components/settings/loaner-agreement/summary-directive.html';
    }

    getDealerwareWebComponentsModule().directive(
        'dealerwareSettingsLoanerAgreementSummary',
        ( ) => new SettingsLoanerAgreementSummaryDirective()
    );

}
